<template>
  <v-container class="container">
    <StrategyReport />
  </v-container>
</template>
<script>
import StrategyReport from '../components/StrategyReport2.vue';

export default {
  components: {
    StrategyReport,
  },
};
</script>
<style scoped>
.container {
  margin-top: 40px;
}
</style>